const matMathematicalSkills = [
  {
    id: 91,
    question: "If x + 1/x = 5, what is the value of x² + 1/x²?",
    options: ["A. 21", "B. 23", "C. 25", "D. 27"],
    answer: "B"
  },
  {
    id: 92,
    question: "A sum of ₹15,000 is invested at 8% simple interest per annum. Find the interest earned after 3 years.",
    options: ["A. ₹3,200", "B. ₹3,400", "C. ₹3,600", "D. ₹3,800"],
    answer: "C"
  },
  {
    id: 93,
    question: "The average of 5 consecutive integers is 24. What is the largest of these integers?",
    options: ["A. 24", "B. 25", "C. 26", "D. 27"],
    answer: "C"
  },
  {
    id: 94,
    question:
      "A train 150 m long crosses a platform 250 m long in 20 seconds. What is the speed of the train in km/hr?",
    options: ["A. 54 km/hr", "B. 60 km/hr", "C. 72 km/hr", "D. 66 km/hr"],
    answer: "C"
  },
  {
    id: 95,
    question: "If log₂(x) = 5, what is the value of x?",
    options: ["A. 16", "B. 25", "C. 32", "D. 64"],
    answer: "C"
  },
  {
    id: 96,
    question:
      "A can complete a task in 12 days and B can complete the same task in 18 days. Working together, how many days will they take?",
    options: ["A. 7.2 days", "B. 6.8 days", "C. 7.5 days", "D. 8 days"],
    answer: "A"
  },
  {
    id: 97,
    question:
      "The perimeter of a rectangle is 60 cm and its length is twice its breadth. Find the area of the rectangle.",
    options: ["A. 150 cm²", "B. 180 cm²", "C. 200 cm²", "D. 220 cm²"],
    answer: "C"
  },
  {
    id: 98,
    question: "What is the compound interest on ₹10,000 for 2 years at 10% per annum, compounded annually?",
    options: ["A. ₹2,000", "B. ₹2,100", "C. ₹2,200", "D. ₹1,900"],
    answer: "B"
  },
  {
    id: 99,
    question: "Find the roots of the equation x² - 7x + 12 = 0.",
    options: ["A. 3, 4", "B. 2, 6", "C. 3, 5", "D. 4, 6"],
    answer: "A"
  },
  {
    id: 100,
    question: "What is the sum of the first 20 natural numbers?",
    options: ["A. 200", "B. 205", "C. 210", "D. 215"],
    answer: "C"
  },
  {
    id: 101,
    question: "A number is increased by 20% and then decreased by 20%. What is the net percentage change?",
    options: ["A. 0%", "B. -2%", "C. -4%", "D. +4%"],
    answer: "C"
  },
  {
    id: 102,
    question: "A shopkeeper buys an article for ₹800 and sells it for ₹960. What is his profit percentage?",
    options: ["A. 15%", "B. 18%", "C. 20%", "D. 22%"],
    answer: "C"
  },
  {
    id: 103,
    question:
      "A car covers a distance of 360 km at a speed of 60 km/hr. If the speed is increased by 20 km/hr, how much time is saved?",
    options: ["A. 1 hour", "B. 1.5 hours", "C. 2 hours", "D. 2.5 hours"],
    answer: "B"
  },
  {
    id: 104,
    question: "A bag contains 4 red and 6 blue balls. What is the probability of drawing a red ball at random?",
    options: ["A. 1/3", "B. 2/5", "C. 1/2", "D. 3/5"],
    answer: "B"
  },
  {
    id: 105,
    question: "In how many ways can the letters of the word 'BOOK' be arranged?",
    options: ["A. 10", "B. 12", "C. 24", "D. 6"],
    answer: "B"
  },
  {
    id: 106,
    question: "Find the area of a circle with radius 7 cm. (Use π = 22/7)",
    options: ["A. 144 cm²", "B. 154 cm²", "C. 164 cm²", "D. 174 cm²"],
    answer: "B"
  },
  {
    id: 107,
    question: "The sides of a triangle are 5 cm, 12 cm, and 13 cm. What is its area?",
    options: ["A. 25 cm²", "B. 30 cm²", "C. 32.5 cm²", "D. 35 cm²"],
    answer: "B"
  },
  {
    id: 108,
    question: "₹1,200 is divided among A, B, and C in the ratio 2:3:5. What is C's share?",
    options: ["A. ₹500", "B. ₹550", "C. ₹600", "D. ₹650"],
    answer: "C"
  },
  {
    id: 109,
    question:
      "The present age of a father is three times that of his son. After 10 years, the father's age will be twice that of his son. Find the son's present age.",
    options: ["A. 8", "B. 10", "C. 12", "D. 15"],
    answer: "B"
  },
  {
    id: 110,
    question:
      "A boat's speed in still water is 12 km/hr and the speed of the stream is 4 km/hr. Find the time taken to travel 32 km downstream.",
    options: ["A. 1.5 hours", "B. 2 hours", "C. 2.5 hours", "D. 3 hours"],
    answer: "B"
  },
  {
    id: 111,
    question: "Find the sum of the first 10 terms of the arithmetic progression 3, 7, 11, 15, ...",
    options: ["A. 200", "B. 205", "C. 210", "D. 215"],
    answer: "C"
  },
  {
    id: 112,
    question: "Find the volume of a cylinder with radius 7 cm and height 10 cm. (Use π = 22/7)",
    options: ["A. 1440 cm³", "B. 1540 cm³", "C. 1640 cm³", "D. 1740 cm³"],
    answer: "B"
  },
  {
    id: 113,
    question: "What is the LCM of 12 and 18?",
    options: ["A. 24", "B. 30", "C. 36", "D. 72"],
    answer: "C"
  },
  {
    id: 114,
    question: "What is the HCF of 24 and 36?",
    options: ["A. 6", "B. 8", "C. 12", "D. 18"],
    answer: "C"
  },
  {
    id: 115,
    question: "If a + b = 10 and ab = 21, find the value of a² + b².",
    options: ["A. 54", "B. 56", "C. 58", "D. 60"],
    answer: "C"
  },
  {
    id: 116,
    question: "What is the value of sin 30° + cos 60°?",
    options: ["A. 0.5", "B. 1", "C. 1.5", "D. 2"],
    answer: "B"
  },
  {
    id: 117,
    question:
      "In an election, a candidate got 60% of the total votes and won by 4,000 votes. What was the total number of votes?",
    options: ["A. 15,000", "B. 18,000", "C. 20,000", "D. 22,000"],
    answer: "C"
  },
  {
    id: 118,
    question:
      "A vessel contains 40 liters of a mixture of milk and water in the ratio 3:1. How many liters of water should be added to make the ratio 3:2?",
    options: ["A. 5", "B. 8", "C. 10", "D. 12"],
    answer: "C"
  },
  {
    id: 119,
    question: "The sum of two numbers is 45 and their difference is 5. Find the larger number.",
    options: ["A. 20", "B. 22", "C. 25", "D. 27"],
    answer: "C"
  },
  {
    id: 120,
    question: "Find the compound interest on ₹5,000 for 2 years at 10% per annum, compounded annually.",
    options: ["A. ₹1,000", "B. ₹1,050", "C. ₹1,100", "D. ₹1,150"],
    answer: "B"
  }
];

export default matMathematicalSkills;